var map = {
	"./arrow.svg": "53ae",
	"./asterisk.svg": "8027",
	"./broom.svg": "a4ba",
	"./cancel.svg": "f868",
	"./check.svg": "07a6",
	"./gear.svg": "1c32",
	"./graph.svg": "c7d5",
	"./home.svg": "3991",
	"./info.svg": "033f",
	"./list.svg": "b1ed",
	"./logo_da.svg": "3dbd",
	"./logo_flaticon.svg": "ccf2",
	"./logo_vue.svg": "54a2",
	"./mag.svg": "c29c",
	"./message.svg": "2d52",
	"./notice.svg": "2361",
	"./notice_yellow.svg": "f8b0",
	"./pencil.svg": "9005",
	"./pic.svg": "d234",
	"./question.svg": "a25b",
	"./ribbon.svg": "96ee",
	"./rotate90.svg": "20d0",
	"./star.svg": "1cbf",
	"./stopwatch.svg": "872e",
	"./talk_bub.svg": "767b",
	"./test.svg": "6519",
	"./tools.svg": "cb9e",
	"./upload.svg": "a4ce",
	"./write.svg": "03ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "94b3";